import 'bootstrap';
import lightbox from 'lightbox2';
import './frontend';

lightbox.option({
    'resizeDuration': 200,
});